import React, { Component } from 'react';
import { addComment } from '../../actions/index';
import { removeComment, removeAllComments, updateComment } from '../../actions/index';
import { connect } from 'react-redux';
import CommentAdd from "./CommentAdd";
import CommentEdit from "./CommentEdit";
import CommentPollAndResponse from './CommentPollAndResponse';
import { getURL } from '../../backend/Backend';
import { sendJson, deleteItem } from '../../backend/Backend';
import { ListGroup, Pagination, Button, Col, OverlayTrigger, Tooltip, Row } from 'react-bootstrap';
import '../App.css';
import { translate } from "react-i18next";

function emptyComment() {
  return {
    comment: '',
    modificationUser: '',
    eventId: '',
    creationDate: '',
    userId: ''
  };
}

class CommentList extends Component {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
    this.onItemInputChange = this.onItemInputChange.bind(this);
    this.onItemUpdate = this.onItemUpdate.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.onReload = this.onReload.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onCommentEdit = this.onCommentEdit.bind(this);
    this.onCommentDelete = this.onCommentDelete.bind(this);
    this.onCommentRevert = this.onCommentRevert.bind(this);
    this.onPoll = this.onPoll.bind(this);
    this.state = {
      selected: emptyComment(),
      comments: [],
      activePage: 1,
      totalPages: 0,
      invitedUser: this.props.invitedUser,
      edit: false
    };
  }


  onEdit(comment) {
    let oldState = this.state;
    this.setState({
      ...oldState,
      selected: comment,
      edit: !oldState.edit
    });
  }

  async onPoll(id, invitedId,  responseType) {
    if(!id || !responseType){
      return;
    }
    const response = await fetch(getURL('commentpoll/add/' + id + '/'+invitedId+'/'+responseType));
    const polled = await response.json();
    if(polled.id){
       
      let oldState = this.state;
      let newComments = this.state.comments;
      newComments.map(c => {
          if(c.id === polled.userCommentId){
            c.yesCount= polled.yesCount;
            c.noCount= polled.noCount;
          }
      });
     
      this.setState({
        ...oldState,
          comments:newComments
        
      });
    }
  
  }

  async onResponse(id, invitedId,  text) {
    if(!id || !text){
      return;
    }

    let oldComment = this.state.comment;

    oldComment.eventId = this.state.invitedUser.eventId;
    oldComment.email = this.state.invitedUser.email;
    oldComment.userId = this.state.invitedUser.id;
    oldComment.username = this.state.invitedUser.name;
 
    sendJson('post', 'userComments', this.state.comment).then(
        received => {
          this.props.onAdd(received); 
          this.setState({
            comment: emptyComment()
            });
        });

   
    
  
  }

  onDelete(id) {
    fetch(getURL('userComments/delete/' + id ))
      .then((response) => {
        this.props.removeComment(id);
      })
      .catch((error) => {
        console.error(error);
      });

  }


  onCommentEdit(comment) {

    sendJson('put', 'userComments', comment).then(
      received => {
        this.loadComments(this.state.activePage);
      });
  }

  onCommentDelete(id) {
    deleteItem('userComments', id).then(
      received => {
        this.loadComments(this.state.activePage);
      });

  }

  onCommentRevert() {
    this.loadComments(this.state.activePage);
  }

  /*componentWillUnmount(){
      this.props.removeAllComments();
  }*/

  async componentDidMount() {
    this.loadComments(1);
  }

  async onReload() {
    const response = await fetch(getURL(`userComments/${this.props.invitedUser.eventId}/0/`));
    const json = await response.json();
    let oldState = this.state;
    this.setState({
      ...oldState,
      comments: json.content,
      activePage: 1
    });
  }

  onItemInputChange(event) {
    const { name: fieldName, value: fieldValue } = event.target;
    const newComment = {
      ...this.state.selected,
      [fieldName]: fieldValue
    };

    this.setState({
      selected: newComment
    });
  }

  onItemUpdate(comment) {
    sendJson('post', 'userComments/save', comment).then(
      received => {
        this.props.updateComment(received);
      });
  }


  async pageChanged(e) {
    this.loadComments(e.target.text);
  }

  async loadComments(page) {
    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }
    const response = await fetch(getURL(`userComments/${this.state.invitedUser.eventId}/${page - 1}/`));
    const json = await response.json();
    let oldState = this.state;
    this.setState({
      ...oldState,
      comments: json.content,
      totalPages: json.totalPages,
      activePage: page,
      selected: emptyComment(),
      edit: false
    });
  }

// <CommentPoll commentId={comment.id} invitedId={this.state.invitedUser.id} yesCount={comment.yesCount} noCount={comment.noCount} onPoll = {this.onPoll} />
  render() {
    const { t } = this.props;
    let options = {
      weekday: "long", year: "numeric", month: "short",
      day: "numeric", hour: "2-digit", minute: "2-digit"
    };
    return (<div>
      {!this.state.edit ?
        <CommentAdd onAdd={this.onReload} invitedUser={this.state.invitedUser} selected={this.state.selected} />
        :
        ""
      }

      {(this.state.comments) ?
        <ListGroup>
          {this.state.comments.map((comment, i) => {
            let s = new Date(comment.creationDate);
            if (this.state.edit && this.state.selected.id === comment.id) {
              return <CommentEdit selected={comment} onCommentEdit={this.onCommentEdit} onCommentDelete={this.onCommentDelete} onCommentRevert={this.onCommentRevert} key={i}/>
            } else {
              return <div key={i}>
                <Row  className={comment.parentId ? "mt-1 ml-2 borderLeft ":"mt-1"}  >
                  <Col lg={2} md={2} xs={4}>
                    <span className="commentAuthor">{comment.username}</span>
                    <span className="commentTime">{s.toLocaleDateString('de-DE', options)}</span>
                  </Col>
                  <Col lg={8} md={8}>
                    {(comment.userId === this.state.invitedUser.id) ?
                      <OverlayTrigger key="top" placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            {t("bearbeiten")}
                          </Tooltip>
                        }>
                        <Button variant="link" onClick={() => this.onEdit(comment)} size="sm" ><span className="fa fa-edit "></span></Button>
                      </OverlayTrigger>
                      :
                      ""
                    }
                  </Col>
                </Row>

                <Row className={comment.parentId ? "ml-2 borderLeft":""} >
                  <Col > 

                  {comment.parentId ? <p>{"@"+comment.parentName}</p> :""} 
                   {comment.comment}
                  </Col>
                </Row>
                
                <Row className={comment.parentId ? "ml-2 borderLeft":""}>
                  <Col >
                    <CommentPollAndResponse  onAdd={this.onReload}  comment={comment} invitedUser={this.state.invitedUser} yesCount={comment.yesCount} onPoll = {this.onPoll} onResponse = {this.onPoll} />
                    
                  </Col>
                </Row>
                <Row className={comment.parentId ? "ml-2 borderLeft":""}>
                  <Col > <hr></hr></Col>
                </Row>

              </div>
            }
          })}
        </ListGroup>
        :
        ""
      }


      <Pagination onClick={this.pageChanged}>
        {this.state.activePage > 1 ?
          <Pagination.Item>{'<'}</Pagination.Item>
          : ""
        }

        {[...Array(this.state.totalPages).keys()].map(i => {
          return <Pagination.Item active={(i + 1) === this.state.activePage} key={i}>{i + 1}</Pagination.Item>
        })
        }
        {this.state.activePage < this.state.totalPages ?
          <Pagination.Item>{'>'}</Pagination.Item>
          : ""
        }

      </Pagination>
    </div>);
  }
}

let mapStateToProps = (state) => {
  return {
    comments: state.comments.comments
  }
}

let mapDispatchToProps = {
  addComment: addComment,
  removeComment: removeComment,
  removeAllComments: removeAllComments,
  updateComment: updateComment
}

let CommentListContainer =
  connect(mapStateToProps, mapDispatchToProps)(CommentList);

export default translate("translations")(CommentListContainer);
